import { Currency } from '@mobi/utils/money'

export const formatKambiCurrencyWithThousandMultiplier = (amount: number) => {
  return new Currency(amount, { dollarMultiplier: 1_000 }).value
}
